import { CatalogFormFieldEntity } from 'entities/CatalogFormField';
import { arrayChunkInGroups } from 'utils/arrayChunkInGroups';
import { arrayPadEnd } from 'utils/arrayPadEnd';

import { FIELDS_CHUNK_SIZE } from './config';

type SpreadFieldsInColumnsParams = {
  fields: Record<string, CatalogFormFieldEntity[]>;
  showOnlySelected: boolean;
  columnsCount: number;
  isFieldSelected: (fieldId: number) => boolean;
};

export type FieldsChunk = {
  category: string;
  indexInCategory: number;
  chunks: CatalogFormFieldEntity[];
};

export type FieldsColumn = FieldsChunk[];

export const spreadFieldsInColumns = ({
  fields,
  showOnlySelected,
  columnsCount,
  isFieldSelected,
}: SpreadFieldsInColumnsParams): FieldsColumn[] => {
  /** Разделяем все поля в чанки по FIELDS_CHUNK_SIZE штук */
  const allChunks: FieldsChunk[] = [];

  /** Итерируемся по всем категориям */
  Object.entries(fields).forEach(([category, fields]) => {
    /** Если нужно, предварительно отфильтровываем только выбранные поля */
    const filteredFields = showOnlySelected
      ? fields.filter((field) => isFieldSelected(field.id))
      : fields;

    /** Разделяем текущую категорию полей на чанки */
    const categoryChunks = arrayChunkInGroups(
      filteredFields,
      FIELDS_CHUNK_SIZE
    ).map(
      (chunks, chunkIndexInCategory): FieldsChunk => ({
        /** Каждому чанку передаем, какой он по счету в текущей категории */
        indexInCategory: chunkIndexInCategory,
        /** Каждому чанку передаем, к какой категории он относится */
        category,
        chunks,
      })
    );

    allChunks.push(...categoryChunks);
  });

  /** Распределяем все получившиеся чанки по колонкам */
  const chunksByColumns = arrayChunkInGroups(
    allChunks,
    /** По сколько штук чанков в каждую колонку */
    Math.ceil(allChunks.length / columnsCount)
  );

  /**
   * Добавляем пустые колонки справа, если нужно, чтобы достичь нужной длины массива
   */
  return arrayPadEnd(chunksByColumns, () => [], columnsCount);
};
